import styled from 'styled-components';
import { breakpoints, colors } from 'View/Theme';
import { asRem } from 'utils';

export default styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.sleep.blue.c600};
  color: ${colors.sleep.beige.c100};
  width: 100%;
  z-index: 99;
  margin-top: ${asRem(61)};
  overflow: hidden;
  height: ${asRem(280)};

  @media (min-width: ${breakpoints.sm}) {
    height: ${asRem(90)};
  }

  @media (min-width: ${breakpoints.md}) {
    margin-top: ${asRem(72)};
    height: ${asRem(110)};
  }

  @media (min-width: ${breakpoints.lg}) {
    margin-top: ${asRem(80)};
    height: ${asRem(130)};
  }

  .inner {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    box-sizing: border-box;
    width: 100%;
    max-width: 100%;
    padding: ${asRem(8)} ${asRem(16)};
    overflow: hidden;

    @media (min-width: ${breakpoints.sm}) {
      flex-direction: row;
      align-items: center;
      max-width: ${asRem(1400)};
      padding: ${asRem(24)} ${asRem(24)};
    }
  }

  .illu-wrapper {
    flex-shrink: 0;
    display: flex;
    align-items: flex-end;

    @media (min-width: ${breakpoints.sm}) {
      align-items: center;
      margin-right: ${asRem(30)};
    }

    img.freddy {
      height: ${asRem(100)};
      width: auto;
      max-width: 100%;

      @media (min-width: ${breakpoints.sm}) {
        height: ${asRem(150)};
      }

      @media (min-width: ${breakpoints.md}) {
        height: ${asRem(180)};
      }

      @media (min-width: ${breakpoints.lg}) {
        height: ${asRem(270)};
      }
    }
  }

  .text-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin: 0;
    padding: 0;
    gap: 0;

    @media (min-width: ${breakpoints.sm}) {
      align-items: flex-start;
      text-align: left;
    }

    h2,
    p {
      margin: 0 !important;
      padding: 0 !important;
    }

    h2 {
      @media (max-width: ${breakpoints.sm}) {
        margin-top: ${asRem(24)} !important;
      }
    }
    }
  }
`;
